export const LANGUAGES = [
  { label: 'Indonesian', languageCode: 'id' },
  { label: 'English', languageCode: 'en' },
  { label: 'German', languageCode: 'de' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' }
]

export const MAX_MESSAGE_CHARACTERS_LIMIT = 200
export const DEFAULT_LIMIT = 20

export const S3_BUCKET_ENDPOINT = 'https://gs-custom-games-storage.s3.amazonaws.com'

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'authToken'
export const LANGUAGE = 'operator_language'
export const OPERATOR_ID = 'operator_id'
export const ROLE = 'operator_role'

/* ==========================================================================
Operator Roles
========================================================================== */
export const OPERATOR_ROLES = {
  operator: 'OPERATOR',
  operatorUser: 'OPERATOR_USER'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER_TYPE = {
  SCALE: 'scale',
  PULSE: 'pulse'
}

/* ==========================================================================
  TOASTER / NOTIFICATION Types
========================================================================== */
export const TOASTER_TYPE = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = {
  // ----single routes------------
  home: '/',
  crashGame: '/crash-game',
  plinkoGame: '/plinko-game',
  diceGame: '/dice-game',
  flipCoinGame: '/flip-coin-game',
  kenoGame: '/keno-game'
}

/* ==========================================================================
  Game Ids
========================================================================== */

export const GAME_NAMES = {
  TEMPLE_GOLD: 'TEMPLE_GOLD',
  STAR_CATCHER: 'STAR_CATCHER',
  FOLLOW_THE_ARROW: 'FOLLOW_THE_ARROW',
  POWER_OF_THOR: 'POWER_OF_THOR'
}

/* ==========================================================================
  Extra Constants Variables
========================================================================== */
export const PAGINATION_LIMIT = 20
export const MIN_WITHDRAW_AMOUNT = 0.003
export const WITHDRAW_FEES = 0.000006
export const DEFAULT_PAGE_CALLS = 20
export const DEFAULT_TOP_BET_TYPE_LIMIT = 20
export const DEFAULT_MY_BETS_LIMIT = 20
export const DEFAULT_PRECISION_MONEY = 2
export const DEFAULT_AUTO_BET_COUNTER = 3
export const DEFAULT_BET_AMOUNT_SC = 1
export const DEFAULT_BET_AMOUNT_GC = 2500
export const TAB_SELECTION = Object.freeze({
  placed: Symbol('placed'),
  previous: Symbol('previous')
})
export const MIN_PAYOUT = {
  CRASH: 1.1
}

export const APPEND_TYPES = {
  ROUND_STOPPED: 'ROUND_STOPPED',
  ESCAPE: 'ESCAPE'
}

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

export const COIN_CURRENCY_ID = {
  GC: '1',
  SC: '2'
}

export const COIN_CURRENCY_CODES = {
  GC: 'GC',
  SC: 'SC'
}

/* ==========================================================================
  Wallet emit types
========================================================================== */
export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const PROVABLE_FAIR_TEXT = '"Provably fair" is a term that refers to a system or algorithm used in online gambling or gaming that can be mathematically verified to ensure that the results are fair and not manipulated in any way. It is a way for players to know that the game or gambling platform they are using is legitimate and not rigged against them.'

export const TOP_BET_TYPE = {
  BIGGEST_WIN: 'BIGGEST_WIN',
  HUGE_WIN: 'HUGE_WIN',
  MULTIPLIER: 'MULTIPLIER',
  GOLD_COINS: 'GC',
  SWEEPSTAKES_COINS: 'SC'
}

export const CRASH_BET_LISTING_TYPE_TABS = {
  ALL_BETS: 'ALL_BETS',
  MY_BETS: 'MY_BETS',
  TOP_BETS: 'TOP_BETS'
}

/* ==========================================================================
  PLINKO GAME CONSTANTS
========================================================================== */
export const PIN_IN_FIRST_LINE = 3

export const DEFAULT_PLINKO_PINS = 8

export const DEFAULT_PLINKO_RISK_LEVEL = 1

export const DEFAULT_PLINKO_AUTO_BETS = 10

export const DEFAULT_PLINKO_LIGHTNING_MODE_BOARD = {
  betMultipliers: [{ position: [7, 8], multiplier: '2x' }, { position: [13, 10], multiplier: '15x' }, { position: [2, 2], multiplier: '40x' }],
  payouts: [1000, 155, 6.28, 1.09, 0.35, 0.16, 0, 0.02, 0, 0.01, 0, 0.07, 0.3, 1.4, 29.3, 157, 1000]
}

export const BOX_COLORS = {
  red: 'red',
  orange: 'orange',
  pink: 'pink',
  purple: 'purple',
  blue: 'blue',
  green: 'green'
}

export const BOX_COLORS_NUMBERS = {
  red: 1,
  orange: 2,
  pink: 3,
  purple: 5,
  blue: 7,
  green: 8
}

export const getColorOfWinBox = (box, totalLines = 8) => {
  const pegsInRows = Array.from({
    length: totalLines
  },
  (_, rowIndex) => rowIndex + PIN_IN_FIRST_LINE)

  let color = `${BOX_COLORS.green}`

  if (box < BOX_COLORS_NUMBERS.red || (box === (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.red))) {
    color = `${BOX_COLORS.red}`
  } else if (box < BOX_COLORS_NUMBERS.orange || (box === (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.orange))) {
    color = `${BOX_COLORS.orange}`
  } else if (box < BOX_COLORS_NUMBERS.pink || (box >= (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.pink))) {
    color = `${BOX_COLORS.pink}`
  } else if (box < BOX_COLORS_NUMBERS.purple || (box >= (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.purple))) {
    color = `${BOX_COLORS.purple}`
  } else if (box < BOX_COLORS_NUMBERS.blue || (box >= (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.blue))) {
    color = `${BOX_COLORS.blue}`
  }

  return color
}

/* ==========================================================================
  DICE GAME CONSTANTS
========================================================================== */
export const BET_MODES = {
  MANUAL: 'manual',
  AUTO: 'auto',
  STRATEGY: 'strategy'
}

export const MAX_BET_COUNT = {
  DICE_AUTO_BET: 5000
}

export const MAX_INCREASED_BY_PERCENTAGE = {
  DICE: 90
}

export const MIN_INCREASED_BY_PERCENTAGE = {
  DICE: 0.5
}

export const MAX_STOP_ON = {
  DICE: 1e6
}

export const DEFAULT_INCREASE_BY_PERCENTAGE = 5

export const defaultDiceStrategies = [
  {
    label: 'Martingale',
    isDefault: true,
    blocks: [
      {
        id: 'mart1',
        type: 'bets',
        on: {
          type: 'every',
          value: 1,
          betType: 'lose',
          profitType: 'balance'
        },
        do: {
          type: 'increaseByPercentage',
          value: 100
        }
      },
      {
        id: 'mart2',
        type: 'bets',
        on: {
          type: 'every',
          value: 1,
          betType: 'win'
        },
        do: {
          type: 'increaseByPercentage',
          value: 0
        }
      }
    ]
  },
  {
    label: 'Delayed Martingale',
    isDefault: true,
    blocks: [
      {
        id: 'delay1',
        type: 'bets',
        on: {
          type: 'streakGreaterThan',
          value: 3,
          betType: 'lose',
          profitType: 'balance'
        },
        do: {
          type: 'increaseByPercentage',
          value: 100
        }
      },
      {
        id: 'delay2',
        type: 'bets',
        on: {
          type: 'firstStreakOf',
          value: 3,
          betType: 'lose',
          profitType: 'balance'
        },
        do: {
          type: 'increaseByPercentage',
          value: 100
        }
      },
      {
        id: 'delay3',
        type: 'bets',
        on: {
          type: 'every',
          value: 1,
          betType: 'win',
          profitType: 'balance'
        },
        do: {
          type: 'resetAmount',
          value: 0
        }
      }
    ]
  },
  {
    label: 'Paroli',
    isDefault: true,
    blocks: [
      {
        id: 'paroli1',
        type: 'bets',
        on: {
          type: 'every',
          value: 1,
          betType: 'win',
          profitType: 'balance'
        },
        do: {
          type: 'increaseByPercentage',
          value: 100
        }
      },
      {
        id: 'paroli2',
        type: 'bets',
        on: {
          type: 'streakGreaterThan',
          value: 3,
          betType: 'win',
          profitType: 'balance'
        },
        do: {
          type: 'resetAmount',
          value: 0
        }
      },
      {
        id: 'paroli3',
        type: 'bets',
        on: {
          type: 'every',
          value: 1,
          betType: 'lose',
          profitType: 'balance'
        },
        do: {
          type: 'resetAmount',
          value: 0
        }
      }
    ]
  },
  {
    label: "D 'Alembert",
    isDefault: true,
    blocks: [
      {
        id: 'Alembert1',
        type: 'bets',
        on: {
          type: 'every',
          value: 1,
          betType: 'win',
          profitType: 'balance'
        },
        do: {
          type: 'addToAmount',
          value: 1e-8
        }
      },
      {
        id: 'Alembert2',
        type: 'bets',
        on: {
          type: 'every',
          value: 1,
          betType: 'lose',
          profitType: 'balance'
        },
        do: {
          type: 'subtractFromAmount',
          value: 1e-8
        }
      }
    ]
  }
]

export const CURRENCY_SYMBOLS = {
  EUR: '€',
  TRY: '₺',
  BRL: 'R$',
  USD: '$'
}
